import { Button } from "@/components/ui/button";
import {
  bookAssemblySteps,
  type BookAssemblyStep,
} from "@/features/book-assembly/book-assembly.types";

type BookAssemblyStepperProps = {
  currentStep: BookAssemblyStep;
  labels: Record<BookAssemblyStep, string>;
  onStepSelect: (step: BookAssemblyStep) => void;
};

export function BookAssemblyStepper({
  currentStep,
  labels,
  onStepSelect,
}: BookAssemblyStepperProps) {
  return (
    <div
      aria-label="Book export steps"
      className="grid gap-2 border-y border-ink/10 py-3 md:grid-cols-5"
    >
      {bookAssemblySteps.map((step, index) => {
        const active = step === currentStep;

        return (
          <Button
            aria-current={active ? "step" : undefined}
            className="justify-start rounded-full"
            key={step}
            onClick={() => onStepSelect(step)}
            type="button"
            variant={active ? "default" : "ghost"}
          >
            <span className="rounded-full border border-current/20 px-2 py-0.5 text-[10px] uppercase tracking-[0.16em]">
              {index + 1}
            </span>
            <span>{labels[step]}</span>
          </Button>
        );
      })}
    </div>
  );
}
